<div class="continue-reading">
  <input
    #input
    type="checkbox"
    [attr.id]="inputId"
    class="is-vishidden"
    aria-hidden="true"
    (change)="checked.set(input.checked)"
  />

  <div class="collapsible" [attr.aria-hidden]="!checked()">
    <ng-content />
  </div>

  <label
    [attr.for]="inputId"
    class="font-body-1 bold-type nordic-blue-900-text text-icon-primary block pr-xsmall font-body-medium-bold"
  >
    <span class="show-when-not-checked" [attr.aria-hidden]="checked()">
      <fcom-icon [name]="SvgLibraryIcon.CHEVRON_DOWN" class="icon-medium" /><span
        class="font-body-1 pr-xxsmall-l font-body-medium"
        >{{ 'readMore' | finLocalization }}</span
      >
    </span>
    <span class="show-when-checked" [attr.aria-hidden]="!checked()">
      <fcom-icon [name]="SvgLibraryIcon.CHEVRON_UP" class="icon-medium" /><span
        class="font-body-1 pr-xxsmall-l font-body-medium"
        >{{ 'readLess' | finLocalization }}</span
      >
    </span>
  </label>
</div>
